import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { BrandTokens } from "../../../@tokens/BrandTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";


export const style: any = {
    theme: {
        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },

        inputWrapper: {
            backgroundColor: "transparent",
            //minWidth: "276px",
            height: "56px",
            borderRadius: GlobalTokens.BorderRadiusMd,
            border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorLowDark}`,
            padding: `0 ${GlobalTokens.SpacingSizeXxxs}`,
            justifyContent: "space-between",
        },

        input: {
            color: BrandTokens.NeutralColorLowDark,
            lineHeight: GlobalTokens.LineHeightDefault,
            fontWeight: BrandTokens.FontWeightRegular,
            fontSize: GlobalTokens.FontSizeXs,
            fontFamily: BrandTokens.FontFamily,
            textAlign: "left",
        },

        icon: {
            paddingLeft: GlobalTokens.SpacingSizeXxxs,
        },

        label: {
            color: BrandTokens.NeutralColorLowPure,
            lineHeight: GlobalTokens.LineHeightDefault,
            fontWeight: BrandTokens.FontWeightMedium,
            fontSize: GlobalTokens.FontSizeXs,
            fontFamily: BrandTokens.FontFamily,
            paddingBottom: GlobalTokens.SpacingSizeNano,
            textAlign: "left",
        },
        placeholder: {
            color: hexToRGB(
                BrandTokens.NeutralColorLowDark,
                GlobalTokens.OpacityLevelIntense
            ),
        },
        helper: {
            marginTop: GlobalTokens.SpacingSizeNano,
            color: BrandTokens.NeutralColorLowPure,
            fontSize: GlobalTokens.FontSizeXxs,
            fontWeight: BrandTokens.FontWeightRegular,
            fontFamily: BrandTokens.FontFamily,
            lineHeight: GlobalTokens.LineHeightDefault,
            icon: {
                paddingRight: GlobalTokens.SpacingSizeQuarck,
            },
        },

        structure: {
            maxWidth: "400px",
            width: "100%",
            backgroundColor: BrandTokens.NeutralColorHighPure,
            borderRadius: GlobalTokens.BorderRadiusMd,
            color: BrandTokens.NeutralColorLowDark,
            border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorHighMedium}`,
            boxShadow: `${GlobalTokens.ShadowLevel2} ${hexToRGB(
                BrandTokens.NeutralColorLowPure,
                GlobalTokens.OpacityLevelLight
            )}`,
            padding: GlobalTokens.SpacingInsetSizeMd,
        },

        day: {
            height: "40px",
            width: "40px",
            fontFamily: BrandTokens.FontFamily,
            fontSize: GlobalTokens.FontSizeXs,
            lineHeight: GlobalTokens.LineHeightDefault,
            fontWeight: BrandTokens.FontWeightBold,
            color: BrandTokens.NeutralColorLowDark,
        },

        number: {
            height: "40px",
            width: "40px",
            margin: "0px 0px 0px 4px",
            fontFamily: BrandTokens.FontFamily,
            fontSize: GlobalTokens.FontSizeXs,
            lineHeight: GlobalTokens.LineHeightDefault,
            fontWeight: BrandTokens.FontWeightMedium,
            color: BrandTokens.BrandColorPrimaryPure,
            borderRadius: GlobalTokens.BorderRadiusCircular,
            default: {
                color: BrandTokens.BrandColorPrimaryPure,
            },
            inactive: {
                color: BrandTokens.NeutralColorHighDark,
            },
            selected: {
                color: BrandTokens.NeutralColorHighPure,
                backgroundColor: BrandTokens.BrandColorPrimaryPure,
            },
        },

        verticalSpacing: {
            month: {
                marginBottom: GlobalTokens.SpacingSizeXxxs,
            },
            weekDays: {
                marginBottom: GlobalTokens.SpacingSizeXxxs,
            },
            lineDays: {
                marginBottom: GlobalTokens.SpacingSizeNano,
            },
        },

        states: {
            hover: {
                number: {
                    color: BrandTokens.BrandColorPrimaryDark,
                    backgroundColor: BrandTokens.BrandColorPrimaryLight,
                    fontWeight: BrandTokens.FontWeightMedium,
                },
                inputWrapper: {
                    backgroundColor: hexToRGB(
                        BrandTokens.BrandColorPrimaryLight,
                        GlobalTokens.OpacityLevelMedium
                    ),
                },
            },
            focus: {
                border: `${GlobalTokens.BorderWidthThin} solid ${BrandTokens.HighlightColorPure}`,
                borderRadius: GlobalTokens.BorderRadiusSm,
                inputWrapper: {
                    backgroundColor: hexToRGB(
                        BrandTokens.BrandColorPrimaryLight,
                        GlobalTokens.OpacityLevelMedium
                    ),
                },
            },
            actived: {
                label: {
                    color: BrandTokens.BrandColorPrimaryPure,
                },
                inputWrapper: {
                    borderColor: BrandTokens.BrandColorPrimaryPure,
                },
            },
            error: {
                label: {
                    color: BrandTokens.FeedbackColorErrorPure,
                },
                inputWrapper: {
                    borderColor: BrandTokens.FeedbackColorErrorPure,
                    backgroundColor: BrandTokens.FeedbackColorErrorLight,
                },
                helper: {
                    color: BrandTokens.FeedbackColorErrorPure,
                },
            },
            disabled: {
                label: {
                    color: hexToRGB(
                        BrandTokens.NeutralColorLowPure,
                        GlobalTokens.OpacityLevelMedium
                    ),
                },
                inputWrapper: {
                    borderColor: hexToRGB(
                        BrandTokens.NeutralColorLowPure,
                        GlobalTokens.OpacityLevelMedium
                    ),
                    color: hexToRGB(
                        BrandTokens.NeutralColorLowPure,
                        GlobalTokens.OpacityLevelMedium
                    ),
                },
                placeholder: {
                    color: hexToRGB(
                        BrandTokens.NeutralColorLowPure,
                        GlobalTokens.OpacityLevelMedium
                    ),
                },
                helper: {
                    color: hexToRGB(
                        BrandTokens.NeutralColorLowPure,
                        GlobalTokens.OpacityLevelMedium
                    ),
                },
            },
        },
    },
}